module.exports = __webpack_public_path__ + "/bundle/asset/U2_07-3934799c94e4aba325b52ce5bedfad5f.gif";